export default __webpack_public_path__ + "static/media/NTEX CLASS-10 EXAM PATTERN 2026-27.4c970475.pdf";